module.exports = __webpack_public_path__ + "static/sgds_1@2x-08ec8a6832179863ee7cf721e2f969af.png";